import { keepPreviousData, useInfiniteQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getMarketProperties } from '../tradingEndpoints'
import { parseMarketPropertyPage } from '../tradingParser'
import type { MarketPropertyQuery } from '../../types/tradingTypes'

const PAGE_LIMIT = 12

// Marketplace grid (Figma 34796:141104) — properties with at least one open
// listing. Search, filters, "Properties I own" and sort all run server-side;
// the query key carries them so each combination caches on its own.
export function useMarketplaceListingsQuery(query: MaybeRefOrGetter<MarketPropertyQuery>) {
  return useInfiniteQuery({
    queryKey: computed(() => tradingKeys.propertyList(toValue(query))),
    queryFn: ({ pageParam }) =>
      getMarketProperties(toValue(query), pageParam, PAGE_LIMIT).then(parseMarketPropertyPage),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    // Keep the grid on screen while a new search / filter resolves.
    placeholderData: keepPreviousData,
  })
}
